module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg5-c40a40edc2ddf96331215c5af3aee7aa.jpg";